module.exports = __webpack_public_path__ + "static/img/stay_informed_legally.3b414346.png";